// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wiki-tree-slide-attachment[data-v-79e6ce7f]{margin:20px 0}.wiki-tree-slide-attachment .fa-eye.disabled[data-v-79e6ce7f]{opacity:0.5}.wiki-tree-slide-attachment .fa-pencil.disabled[data-v-79e6ce7f]{opacity:0.5}.wiki-tree-slide-attachment .fa[data-v-79e6ce7f]{vertical-align:middle;font-size:25px;margin:0 4px}\n", ""]);
// Exports
module.exports = exports;
